import React, { Component } from 'react';
import Search from '../../../components/Search';
import DataTable from '../../../components/DataTable';
import { connect } from 'react-redux'
import {Card, CardBody, CardTitle} from "reactstrap";
import { setSearchData } from '../../../actions/search';
import {withRouter} from 'react-router';
import { Button, Form, FormGroup, Label, Input, FormText, Table } from 'reactstrap';
class FrontEndUserAddresses extends Component {   

    constructor(props, context) {
        super(props, context);
        this.checkForChecked = this.checkForChecked.bind(this);
    }
    
    componentWillMount() {

        this.props.updateSearchData(this.props.clientData.allAddresses) 
    }
  
   mapMetaValuesToCheckboxes(value, key) {
        return(
            <tr key={key}>
                <td>
                    <Label check for={"address_id"+ value.dp_address_id}>
                        <Input defaultChecked={this.checkForChecked(value.dp_address_id)} onChange={(e) => this.props.setCheckedAddresses(e)} type="checkbox" value={value.dp_address_id} id={"address_id"+ value.dp_address_id} />
                        &nbsp; {value.street} {value.zipcode} {value.city}
                    </Label>
                </td>               
            </tr>
        )
    }

    checkForChecked(valueId) {
        if(!this.props.attachedAddresses)        
            return false;
        
        if(valueId in this.props.attachedAddresses){
            return true;
        }

        return false;
   }


    render() {
        let data = this.props.searchData.data ? this.props.searchData.data : this.props.clientData.allAddresses        
        return (
            <div className="animated fadeIn">
                <div className="card-footer">                   
                    <Search data={this.props.clientData.allAddresses} keys_to_filter={['vve_address_name','street', 'zipcode', 'city']}/>
                </div>
                <CardTitle><i className="fa fa-pin"></i> Koppel adressen </CardTitle>
                <Table>                                    
                    <thead>
                      <tr>
                        <th>Adres</th>                        
                      </tr>
                    </thead>
                    <tbody>
                        {data.map((value, key) => this.mapMetaValuesToCheckboxes(value, key))}
                    </tbody>
                </Table>
            </div>
        )
    }
}


function mapStateToProps(state, ownProps) {

    return {
        clientData: state.ClientDataReducer, 
        searchData: state.SearchDataReducer       
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        updateSearchData: (data) => dispatch(setSearchData(data))
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FrontEndUserAddresses))



// WEBPACK FOOTER //
// ./src/views/User/Addresses/index.js